import { render } from "./LicenseExtraContent.vue?vue&type=template&id=65d7581c&ts=true"
import script from "./LicenseExtraContent.vue?vue&type=script&lang=ts"
export * from "./LicenseExtraContent.vue?vue&type=script&lang=ts"

import "./LicenseExtraContent.vue?vue&type=style&index=0&id=65d7581c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__